module.exports = __webpack_public_path__ + "img/janis.ac55f247.png";